import { createAction, props } from '@ngrx/store';

export const DeleteIntegrationSystem = createAction('[Integration Management: Actions]: Delete Integration System');

export const DeleteIntegrationSuccess = createAction(
  '[Integration Management: Actions]: Delete Integration Success',
  props<{ response: any }>(),
);

export const DeleteIntegrationFailed = createAction(
  '[Integration Management: Actions]: Delete Integration Failed',
  props<{ error: any }>(),
);

export const OpenConfirmDialogForDeleteRow = createAction(
  '[Integration Management: Actions]: Open Confirm Dialog For Delete Row',
);

export const ChangeSidenavStatus = createAction('[Integration Management: Actions]: Opened Sidenav Status Changed');

export const ChangeStatusSystem = createAction(
  '[Integration Management: Actions]: Change Status System',
  props<{ data: any }>(),
);

export const ChangeStatusSystemFailed = createAction(
  '[Integration Management: Actions]: Change Status System Failed',
  props<{ error: any }>(),
);

export const ChangeStatusSystemSuccess = createAction(
  '[Integration Management: Actions]: Changed Status System Success',
  props<{ res: any }>(),
);

export const DeactivateSystem = createAction(
  '[Integration Management: Actions]: Deactivate System',
  props<{ selectedRow: any }>(),
);

export const ActivateSystem = createAction(
  '[Integration Management: Actions]: Activate System',
  props<{ selectedRow: any }>(),
);

export const OpenConfirmDialogForDeactivateStatus = createAction(
  '[Integration Management: Actions]: Open Confirm Dialog For Deactivate Status',
  props<{ selectedRow: any }>(),
);
